<div
  class="col-md-1 text-end w-10 p-3 mt-4"
  *ngIf="isVisible"
  class="back-to-top"
  (click)="scrollToTop()"
>
  <a
    class="text-white text-decoration-none mx-auto d-flex flex-column"
    style="width: 60px"
  >
    <img src="public/icons/backtop.svg" alt="Back to Top" class="me-4" />
  </a>
</div>
